import { S_READ, S_STAFF, S_ADMIN } from './constants';
import theme from '../utilities/theme';
import { brandFromHost } from '../utilities';

export function getUserType(role) {
  if (role === S_READ) return S_READ;
  else if (role === S_STAFF) return S_STAFF;
  else if (role === S_ADMIN) return S_ADMIN;
  else return null;
}

export function convertDate(data) {
  const d = new Date(data);
  return d.getDate() + '/' + (d.getMonth() + 1) + '/' + d.getFullYear();
}

export function commaFormatted(amount) {
  if (amount <= 0) {
    return 0;
  }

  return amount
    .toString()
    .replace(/,/g, '')
    .replace(/\B(?=(\d{3})+(?!\d))/g, ',');
}

export function ThemeHelper() {
  const { hostname } = window.location;
  const brand = brandFromHost(hostname);
  const customTheme = theme(brand);
  const colors = customTheme.color;
  const fonts = customTheme.font_family;
  const backgroundColor = customTheme.background_color;
  const headerColor = customTheme.header_color;
  const footerColor = customTheme.footer_color;
  const logo = customTheme.logo;
  const fontDarkColor = colors.fontDark;
  const successColor = colors.success;
  const warnColor = colors.warn;
  const grayColor = colors.gray;
  const darkGrayColor = colors.darkGray;
  const blackColor = colors.black;
  const redColor = colors.red;
  const buttonColor = colors.button;
  const hoverButtonColor = colors.hoverButton;
  const whiteColor = colors.white;
  const basicFont = fonts.Basic;
  const normalFont = fonts.Normal;
  const boldFont = fonts.Bold;

  return [
    backgroundColor,
    headerColor,
    footerColor,
    logo,
    fontDarkColor,
    successColor,
    warnColor,
    grayColor,
    blackColor,
    darkGrayColor,
    redColor,
    buttonColor,
    hoverButtonColor,
    whiteColor,
    basicFont,
    normalFont,
    boldFont,
  ];
}
